import { InjectionToken } from '@angular/core';
import { FirebaseApp } from 'firebase/app';
import { Auth } from 'firebase/auth';
import { Firestore } from 'firebase/firestore';
import { FirebaseStorage } from 'firebase/storage';

/**
 * DI tokens for the Firebase SDK singletons. These replace the injectables that
 * `@angular/fire` used to provide (`FirebaseApp`, `Firestore`, `Auth`, `Storage`),
 * allowing the rest of the app to consume the modular Firebase SDK directly while
 * keeping the instances injectable/testable.
 */
export const FIREBASE_APP = new InjectionToken<FirebaseApp>('FIREBASE_APP');
export const FIRESTORE = new InjectionToken<Firestore>('FIRESTORE');
export const FIREBASE_AUTH = new InjectionToken<Auth>('FIREBASE_AUTH');
export const FIREBASE_STORAGE = new InjectionToken<FirebaseStorage>(
	'FIREBASE_STORAGE',
);
